import { render, staticRenderFns } from "./chargeOrder.vue?vue&type=template&id=4b4f624b&scoped=true"
import script from "./chargeOrder.vue?vue&type=script&lang=js"
export * from "./chargeOrder.vue?vue&type=script&lang=js"
import style0 from "./chargeOrder.vue?vue&type=style&index=0&id=4b4f624b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4f624b",
  null
  
)

export default component.exports